import * as G from "@olton/guardian"

globalThis.G = G